import React from 'react'
import {
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@mui/material";

const guestOrgData = [];

function VechileComponent() {
  return (
    <Grid container justifyContent={'center'} >
      <h4 style={{ textAlign: 'center' }}>Vechile / வாகனம் Entry</h4>
      <>
        <Grid item container>
          <Grid item xs={12} textAlign={"center"}>
            <h4>Vechile</h4>
          </Grid>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Date / தேதி</TableCell>
                <TableCell align="center">Vehicle No / வாகன எண்</TableCell>
                <TableCell align="right">Driver Name / டிரைவர் பெயர்</TableCell>
                <TableCell align="right">Out time / வெளியேறும் நேரம்</TableCell>
                <TableCell align="center">In time / உள்ளே நேரம்</TableCell>
                <TableCell align="right"></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {guestOrgData && guestOrgData.length > 0 ? (
                guestOrgData.map((row) => (
                  <TableRow
                    key={row.id}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {row.in_date}
                    </TableCell>
                    <TableCell align="center">{row.visitor_name}</TableCell>
                    <TableCell align="center">{row.in_time}</TableCell>
                    <TableCell align="center">{row.out_time}</TableCell>
                    <TableCell align="center">{row.vehicle_no}</TableCell>

                    <TableCell align="right">
                      {/* <CustomButton onClick={() => updateStatus(row.id)}>
                          Out / வெளியே
                        </CustomButton> */}
                    </TableCell>
                  </TableRow>
                ))
              ) : (
                <h4>No data found</h4>
              )}
            </TableBody>
          </Table>
        </Grid>
      </>
    </Grid>
  )
}

export default VechileComponent